module.exports = __webpack_public_path__ + "static/media/04062021_mail_outline_140px.bf7021ad.svg";